import { useTheme } from "@/hooks/use-theme";
import { Computer, Moon, Sun } from "lucide-react";
import {
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/podkit/select/Select";
import { type FC, forwardRef } from "react";
import { themes, type Theme } from "@/contexts/ThemeProvider";

export const ThemeToggle: FC = () => {
    const { theme, setTheme } = useTheme();
    return (
        <Select name="theme" value={theme} onValueChange={setTheme}>
            <SelectTrigger loading={false}>
                <SelectValue>
                    <ThemeValue theme={theme} />
                </SelectValue>
                <SelectContent>
                    <SelectGroup>
                        {themes.map((theme) => (
                            <SelectItem key={"item-" + theme} value={theme}>
                                <ThemeValue theme={theme} />
                            </SelectItem>
                        ))}
                    </SelectGroup>
                </SelectContent>
            </SelectTrigger>
        </Select>
    );
};

const ThemeValue = forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement> & { theme: Theme }>(
    ({ theme }, ref) => (
        <div className="flex items-center gap-2" ref={ref}>
            <ThemeIcon theme={theme} />
            <span className="capitalize">{theme}</span>
        </div>
    ),
);
ThemeValue.displayName = "ThemeValue";

const ThemeIcon: FC<{ theme: Theme }> = ({ theme }) => {
    switch (theme) {
        case "light":
            return <Sun className="h-[1.2rem] w-[1.2rem]" />;
        case "dark":
            return <Moon className="h-[1.2rem] w-[1.2rem]" />;
        case "system":
            return <Computer className="h-[1.2rem] w-[1.2rem]" />;
    }
};
